import { render, staticRenderFns } from "./CulturaHeader.vue?vue&type=template&id=26107e3b&scoped=true"
import script from "./CulturaHeader.vue?vue&type=script&lang=js"
export * from "./CulturaHeader.vue?vue&type=script&lang=js"
import style0 from "./CulturaHeader.vue?vue&type=style&index=0&id=26107e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26107e3b",
  null
  
)

export default component.exports